export enum RefresherStatus {
  loading = 'loading',
  error = 'error',
  done = 'done',
}
